// Utils
import { UserUtils } from 'utils';
import MODULE_KEYWORDS from 'components/Modules/keywords';

export const resolvePaymentOrderInvoiceContext = ({
	selectedSubModule,
	payloadIsInvoice,
}) => {
	const { BILLINGS } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;

	if (selectedSubModule?.key === BILLINGS.INVOICES) return true;
	if (selectedSubModule?.key === BILLINGS.PAYMENTS) return false;

	return !!payloadIsInvoice;
};

export const canViewPaymentOrderMargins = ({
	profile,
	isInvoice,
	requestedCapability,
}) => {
	const entityId = profile?.entity?.id;
	const mainEntityId = profile?.organization?.settings?.mainEntity;
	const hasEntityContext =
		entityId !== undefined &&
		entityId !== null &&
		mainEntityId !== undefined &&
		mainEntityId !== null;
	const isMainEntity =
		hasEntityContext && UserUtils.isUserBelongsMainEntity(profile);
	const allowedByContext = !isInvoice || isMainEntity;

	return allowedByContext && requestedCapability !== false;
};

export const isContractorPaymentInvoiceContext = ({ profile, isInvoice }) => {
	if (!isInvoice) return false;

	const entityId = profile?.entity?.id;
	const mainEntityId = profile?.organization?.settings?.mainEntity;
	const hasEntityContext =
		entityId !== undefined &&
		entityId !== null &&
		mainEntityId !== undefined &&
		mainEntityId !== null;

	return hasEntityContext && !UserUtils.isUserBelongsMainEntity(profile);
};
